var RGBtoHSL = require("./dist/index.min.js");

module.exports = RGBtoHSL;